var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Endereco',{attrs:{"listaDeErros":_vm.dadosRetorno.listaDeErros,"flagsDeControle":_vm.flagsDeControle,"consultaUnidadesFederativas":_vm.obterUnidadesFederativas},model:{value:(_vm.formulario),callback:function ($$v) {_vm.formulario=$$v},expression:"formulario"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }